import { useEffect, useRef, EffectCallback, DependencyList } from 'react'

// 初次不渲染
export const useDidUpdateEffect = (
  fn: EffectCallback,
  inputs: DependencyList
) => {
  const didMountRef = useRef(false)
  useEffect(() => {
    if (didMountRef.current) {
      fn()
    } else {
      didMountRef.current = true
    }
  }, inputs)
}
